<template>
    <div>
        <el-dialog title="特许经营合同" :visible.sync="jcxy" :close-on-click-modal="false" width="800px" center>
            <el-form :inline="true" ref="addForm" :model="reqCreate" label-width="100px" :rules="rules">
                <el-form-item label="签署公司（乙方）" prop="signSealId" class="item">
                    <el-select v-model="reqCreate.signSealId" style="width:620px" @change="selectJms" clearable
                        placeholder="请选择签署公司（乙方" filterable>
                        <el-option v-for="(item, index) in allJMSList" :key="index" :label="item.companyName"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="联系电话" prop="tel">
                    <el-input v-model="reqCreate.tel" style="width:255px" clearable maxlength="11" show-word-limit
                        placeholder="签署公司的联系电话"></el-input>
                </el-form-item>

                <el-form-item label="信用代码" prop="xinyongdaima">
                    <el-input v-model="reqCreate.xinyongdaima" style="width:255px" clearable show-word-limit
                        placeholder="签署公司的三合一社会信用代码"></el-input>
                </el-form-item>

                <el-form-item label="联系地址" prop="address">
                    <el-input v-model="reqCreate.address" style="width:623px" show-word-limit placeholder="签署公司的联系地址"
                        clearable></el-input>
                </el-form-item>


                <el-form-item label="特许开始期限" prop="dateStart" class="nian">
                    <el-date-picker v-model="reqCreate.dateStart" style="width:255px" type="date"
                        placeholder="请选择特许开始期限" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>

                <el-form-item label="特许截止期限" prop="dateEnd" class="nian">
                    <el-date-picker v-model="reqCreate.dateEnd" style="width:255px" type="date" placeholder="请选择特许截止期限"
                        value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>

                <el-row>
                    <el-form-item label="名称" prop="mingcheng">
                        <el-input v-model="reqCreate.mingcheng" style="width:255px" clearable show-word-limit
                            placeholder="请输入甲方名称"></el-input>
                    </el-form-item>
                    <el-form-item label="纳税号" prop="nashuihao">
                        <el-input v-model="reqCreate.nashuihao" style="width:255px" clearable show-word-limit
                            placeholder="请输入纳税号"></el-input>
                    </el-form-item>
                    <el-form-item label="地址、电话" prop="dizhidianhua">
                        <el-input v-model="reqCreate.dizhidianhua" style="width:255px" clearable show-word-limit
                            placeholder="请输入地址、电话"></el-input>
                    </el-form-item>
                    <el-form-item label="开户行及账号" prop="kaihuhangzhanghao">
                        <el-input v-model="reqCreate.kaihuhangzhanghao" style="width:255px" clearable show-word-limit
                            placeholder="请输入开户行及账号"></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="第几年开始收取" prop="startYear" class="nian">
                        <el-input v-model="reqCreate.startYear" style="width:255px" clearable show-word-limit
                            placeholder="请输入系统使用费第几年开始收取"><template slot="append">年</template></el-input>
                    </el-form-item>

                    <el-form-item label="合同日期" prop="htrq">
                        <el-date-picker v-model="reqCreate.htrq" type="date" placeholder="选择日期"
                            value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                </el-row>




            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="jcxy = false">取消</el-button>
                <el-button type="primary" @click="yulan()">预览合同</el-button>
            </span>
        </el-dialog>

        <el-dialog title="合同生成预览" :visible.sync="PDFVisible" :close-on-click-modal="false" width="900px" center>
            <iframe name="ifram11" :src="contractUrl" scrolling="auto" frameborder="0"
                style="width:870px;height:800px"></iframe>

            <span slot="footer" class="dialog-footer">
                <el-button @click="PDFVisible = false">取 消</el-button>
                <el-button type="primary" @click="sendContractBtn">发送合同</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import contract from '@/script/api/contractapi';
import wmsApi from "@/script/api/wmsApi";
import globalData from '@/components/common/globaldata/global.data';
export default {
    data() {
        return {
            id: null,
            jcxy: false,
            PDFVisible: false,
            contractUrl: null,
            allJMSList: [],

            addField: {},
            singList: [],
            choosePerson: {}, //下拉框所选人
            rules: {
                signSealId: [{ required: true, message: "请选择签署公司", trigger: "blur" }],
                tel: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
                xinyongdaima: [{ required: true, message: "请输入信用代码", trigger: "blur" }],
                address: [{ required: true, message: "请输入联系地址", trigger: "blur" }],
                dateStart: [{ required: true, message: "请选择特许开始时间", trigger: "change" }],
                dateEnd: [{ required: true, message: "请选择特许截至时间", trigger: "change" }],
            },
            reqCreate: {
                xinyongdaima: '',
                htrq: '',

                "address": "",
                "collectAccount": "",
                "collectBankName": "",
                "collectUserName": "",
                "contractFileId": "",
                "contractNo": "",
                "createTime": "",
                "createUserId": '',
                "createUserName": "",
                dateEnd: "",
                dateStart: "",
                // "feeDate": "",
                "fraId": '',
                "fraName": "",
                "id": '',
                "idCard": "",
                "jsonData": "",
                "processId": "",
                "remark": "",
                "signName": "",
                "signSealId": '',
                "state": '',
                // "storeNumber": '',
                "tel": "",
                "templateNo": "",
                "type": '',
                "startYear": ''
            }
        };
    },
    methods: {
        showDetail() {
            this.getAllJMS();
            this.jcxy = true;

            this.reqCreate = {
                xinyongdaima: '',
                htrq: '',
                "address": "",
                "collectAccount": "",
                "collectBankName": "",
                "collectUserName": "",
                "contractFileId": "",
                "contractNo": "",
                "createTime": "",
                "createUserId": '',
                "createUserName": "",
                dateEnd: "",
                dateStart: "",
                // "feeDate": "",
                "fraId": '',
                "fraName": "",
                "id": '',
                "idCard": "",
                "jsonData": "",
                "processId": "",
                "remark": "",
                "signName": "",
                "signSealId": '',
                "state": '',
                // "storeNumber": '',
                "tel": "",
                "templateNo": "",
                "type": '',

                mingcheng: '',
                nashuihao: '',
                dizhidianhua: '',
                kaihuhangzhanghao: '',
                startYear: ''
            };

        },
        selectJms(id) {
            if (id == null || id == '') {
                this.choosePerson = {};
                this.reqCreate.fraId = "";
                this.reqCreate.xinyongdaima = "";
                this.reqCreate.tel = "";
                this.reqCreate.address = "";
            }
            if (id != null) {
                let ren = {};
                this.allJMSList.forEach(e => {
                    if (e.id == id) {
                        ren = e;
                    }
                })
                this.choosePerson = ren;
                this.reqCreate.fraId = ren.franchiseeId;
                this.reqCreate.xinyongdaima = ren.creditCode;
                this.reqCreate.tel = ren.tel;
                console.log(ren);
                this.reqCreate.address = ren.address;
            }
        },
        checkFm() {

            if (this.reqCreate.signSealId == null || this.reqCreate.signSealId == '') {
                this.$message.error('请选择签署公司');
                return false;
            }
            if (this.reqCreate.tel == null || this.reqCreate.tel == '' || this.reqCreate.tel.length != 11) {
                this.$message.error('请输入联电话，或输入正确的电话号码');
                return false;
            }
            if (this.reqCreate.xinyongdaima == null || this.reqCreate.xinyongdaima == '') {
                this.$message.error('请输入信用代码');
                return false;
            }

            if (this.reqCreate.address == null || this.reqCreate.address == '') {
                this.$message.error('请输入联系地址');
                return false;
            }
            // if (this.reqCreate.storeNumber == null || this.reqCreate.storeNumber == '') {
            //     this.$message.error('加盟店数量不能为空');
            //     return false;
            // }

            if (this.reqCreate.dateStart == null || this.reqCreate.dateStart == ''
                || this.reqCreate.dateEnd == null || this.reqCreate.dateEnd == '') {
                this.$message.error('特许期限日期不能为空');
                return false;
            }

            // if (this.reqCreate.feeDate == null || this.reqCreate.feeDate == '') {
            //     this.$message.error('系统使用服务费日期不能为空');
            //     return false;
            // }

            if (this.reqCreate.htrq == null || this.reqCreate.htrq == '') {
                this.$message.error('请选择合同日期');
                return false;
            }

            return true;
        },
        fillTemplate() {
            let addField = {
                fraName: this.choosePerson.companyName,
                xinyongdaima: this.reqCreate.xinyongdaima,
                address: this.reqCreate.address,
                tel: this.reqCreate.tel,
                fraName2: this.choosePerson.companyName,
                xinyongdaima2: this.reqCreate.xinyongdaima,
                address2: this.reqCreate.address,
                tel2: this.reqCreate.tel,
                year: this.reqCreate.dateStart.substring(0, 4),
                month: this.reqCreate.dateStart.substring(5, 7) * 1,
                day: this.reqCreate.dateStart.substring(8, 10) * 1,
                zhi_year: this.reqCreate.dateEnd.substring(0, 4),
                zhi_month: this.reqCreate.dateEnd.substring(5, 7) * 1,
                zhi_day: this.reqCreate.dateEnd.substring(8, 10) * 1,
                // collectUserName: this.reqCreate.collectUserName,
                // collectAccount: this.reqCreate.collectAccount,
                // collectBankName: this.reqCreate.collectBankName,
                jia_year: this.reqCreate.htrq.substring(0, 4),
                jia_month: this.reqCreate.htrq.substring(5, 7) * 1,
                jia_day: this.reqCreate.htrq.substring(8, 10) * 1,
                yi_year: this.reqCreate.htrq.substring(0, 4),
                yi_month: this.reqCreate.htrq.substring(5, 7) * 1,
                yi_day: this.reqCreate.htrq.substring(8, 10) * 1,

                mingcheng: this.reqCreate.mingcheng,
                nashuihao: this.reqCreate.nashuihao,
                dizhidianhua: this.reqCreate.dizhidianhua,
                kaihuhangzhanghao: this.reqCreate.kaihuhangzhanghao,

                // shuliang:this.reqCreate.storeNumber,
                // con_year:this.reqCreate.feeDate.substring(0, 4),
                // con_month:this.reqCreate.feeDate.substring(5, 7) * 1,
                // con_day:this.reqCreate.feeDate.substring(8, 10) * 1,

                jia: '',
                yi: '',
                Contract_no: '',
                startYear: this.reqCreate.startYear
            };
            this.addField = addField;
            return addField;
        },
        yulan() {
            this.$refs['addForm'].validate(valid => {
                if (valid) {
                    let temFields = this.fillTemplate();
                    this.reqCreate.tempSignData = temFields;

                    let reqData = {
                        // cityId: this.reqCreate.cityId,
                        fraId: this.reqCreate.fraId,
                        eventType: 203,
                        name: '特许经营合同',
                        simpleFormFields: temFields
                    };

                    const loading = this.$loading({
                        lock: true,
                        text: '努力生成中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.5)'
                    });

                    contract
                        .$ajaxPreviewFile(reqData)
                        .then((res) => {
                            if (res.data.errno == 0) {
                                loading.close();
                                // console.log(res);
                                this.contractUrl = res.data.data.downloadUrl;
                                this.reqCreate.templateNo = res.data.data.templateNo; //模板编号
                                this.reqCreate.contractNo = res.data.data.contractNo; //合同编号
                                this.reqCreate.contractFileId = res.data.data.fileId; //合同文件文件id
                                this.PDFVisible = true;
                            } else {
                                loading.close();
                                this.$message({
                                    showClose: true,
                                    message: res.data.data,
                                    type: 'warning',
                                    duration: 8000
                                });
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            })
        },
        sendContractBtn() {
            const loading = this.$loading({
                lock: true,
                text: '发送合同中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });

            this.reqCreate.fraId = globalData.franchisee.id;
            this.reqCreate.createUserId = this.reqCreate.fraId;// globalData.userInfo.id;
            this.reqCreate.createUserName = globalData.userInfo.userName;
            this.reqCreate.type = 203;

            contract.$ajaxJmsSignContract(this.reqCreate).then((res) => {
                loading.close();
                if (res.data.errno == 0) {
                    this.$message.success('合同已发送！');
                    // this.querySearch();
                    this.$emit('querySearch');
                    this.PDFVisible = false;
                    this.jcxy = false;
                } else {
                    this.$message.warning(res.data.data);
                }
            });
        },
        getAllJMS() {
            //城市下拉框
            contract
                .$ajaxJmsgetJMSAll()
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.allJMSList = res.data.data;
                    }
                });
        },
    }
};
</script>
<style lang="">
.item .el-form-item__label{
    color:#f56c6c;
     font-weight:bold;
     font-size:11px
  }

  .nian .el-form-item__label{
     font-size:11px
  }
</style>
